/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasSecurityRequirement
 */
export class Oas20SecurityRequirement extends OasSecurityRequirement {
    constructor() {
        super();
    }
}
Oas20SecurityRequirement["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20SecurityRequirement";
Oas20SecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




